import { createSelector } from "reselect";

export const statusesSelector = createSelector(
    state => state.services.status,
    state => state
);